import catalogue from './catalogue'
import ContextualVideoGuide from '@/components/ContextualVideoGuide.vue'
const normaliser = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
export default {
    name: 'GuideUtilisation',
    components: { ContextualVideoGuide },
    data: () => ({ recherche: '', categorie: '' }),
    computed: {
        role() { return this.$store.getters.activeRole || {} },
        roleNom() { return this.role.nom || '' },
        roleLibelle() {
            const noms = { ROLE_CAISSIERE: 'Caisse', ROLE_CAISSIERE_INTERMITENT: 'Caisse', ROLE_ACCUEIL: 'Accueil',
                ROLE_ADMINISTRATEUR: 'Administration', ROLE_COMPTABLE: 'Comptabilité', ROLE_TRESORERIE: 'Trésorerie',
                ROLE_MEDECIN: 'Médecin', ROLE_INFIRMIER: 'Infirmier', ROLE_SAGE_FEMME: 'Sage-femme',
                ROLE_MEDECIN_BIOLOGISTE: 'Biologiste', ROLE_RESPONSABLE_LOGISTIQUE: 'Logistique',
                ROLE_TECH_SUP_LABO: 'Laboratoire', ROLE_TECHNICIEN_IMAGERIE: 'Imagerie', ROLE_RADIOLOGUE: 'Radiologue',
                ROLE_MEDECIN_TRAVAIL: 'Médecine du travail', ROLE_INFIRMIER_MEDECINE_TRAVAIL: 'Infirmerie du travail',
                ROLE_AGENT_SECURITE: 'Sécurité',
                ROLE_PHARMACIEN: 'Pharmacie', ROLE_PHARMACIEN_INTERMITENT: 'Pharmacie',
                ROLE_RECEPTIONNISTE: 'Réception', ROLE_RECEPTIONNISTE_INTERMITENT: 'Réception' }
            return noms[this.roleNom] || 'Prise en main'
        },
        articles() { return catalogue.filter(item => !item.roles.length || item.roles.includes(this.roleNom)) },
        categories() { return [...new Set(this.articles.map(item => item.category))] },
        resultats() {
            const mots = normaliser(this.recherche).trim().split(/\s+/).filter(Boolean)
            return this.articles.filter(item => (!this.categorie || item.category === this.categorie) &&
                mots.every(mot => normaliser([item.title, item.summary, item.category, ...item.steps, item.tip].join(' ')).includes(mot)))
        },
        article() { return this.articles.find(item => item.id === this.$route.query.article) || null },
        indisponible() { return !!this.$route.query.article && !this.article },
        associes() { return this.article ? this.articles.filter(item => item.category === this.article.category && item.id !== this.article.id) : [] }
    },
    watch: {
        roleNom() { this.recherche = ''; this.categorie = ''; this.accueil() }
    },
    methods: {
        ouvrir(item) {
            if (!this.articles.some(article => article.id === item.id)) return
            return this.$router.replace({ query: { article: item.id } }).then(() => this.focusTitre())
        },
        accueil() {
            if (!this.$route.query.article) return
            return this.$router.replace({ query: {} })
        },
        chercher() { this.accueil(); this.categorie = '' },
        choisirCategorie(value) { this.categorie = value; this.recherche = ''; this.accueil() },
        reinitialiser() { this.recherche = ''; this.categorie = ''; this.accueil() },
        focusTitre() { this.$nextTick(() => { if (this.$refs.titre) this.$refs.titre.focus() }) }
    }
}
